import { Component, OnInit } from '@angular/core'
import { ArticleEmbedCommon } from 'src/app/shared/components/article-embed/article-embed-common'
import { AsyncPipe } from '@angular/common'

@Component({
    selector: 'situation-article-embed',
    templateUrl: './situation-article-embed.component.html',
    styleUrls: ['./situation-article-embed.component.scss'],
    imports: [AsyncPipe]
})
export class SituationArticleEmbedComponent extends ArticleEmbedCommon implements OnInit {

  constructor() {
    super()
    this.contentSet = 'situations/parts'
  }
}